import * as SwitchPrimitive from '@radix-ui/react-switch';

export const ToggleSwitch = ({ checked, onCheckedChange, disabled, className, ...props }) => (
    <SwitchPrimitive.Root
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className={`
      relative inline-flex h-6 w-11 
      items-center rounded-full 
      bg-gray-200 
      data-[state=checked]:bg-blue-600 
      transition-colors 
      focus:outline-none 
      focus:ring-2 
      focus:ring-blue-500 
      focus:ring-offset-2 
      disabled:cursor-not-allowed 
      disabled:opacity-50
      ${className}
    `}
        {...props}
    >
        <SwitchPrimitive.Thumb
            className={`
        block h-5 w-5 
        rounded-full 
        bg-white 
        shadow-lg 
        transition-transform 
        data-[state=checked]:translate-x-5 
        data-[state=unchecked]:translate-x-1
      `}
        />
    </SwitchPrimitive.Root>
); 